import ReactAdminContainer from "root/s360components/Administration/ReactAdminContainer";
import UserEditContainer from "root/s360components/UserRename/UserEditContainer";
import './UserEditPage.scss';

const UserEditPage = () =>
{
    return (
        <ReactAdminContainer>
            <UserEditContainer />
        </ReactAdminContainer>
    )
}

export default UserEditPage;